import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Checkbox } from 'ui-components/components/checkbox/';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuTitleWithLabel } from 'ui-components/components/dropdown-menu-title-with-label';
import { noop } from 'ui-components/default-props/noop';
import { FormattedMessagePropType } from '../../../../prop-types/intl';

import style from './inputs.module.css';
import { emptyObject } from 'ui-components/default-props/empty';

const CONSEQUENTIAL_LOSSES = [
  { id: '750', label: '£750' },
  { id: '1000', label: '£1000' },
  { id: '2500', label: '£2500' },
  { id: '5000', label: '£5000' },
  { id: '7500', label: '£7500' },
  { id: '10000', label: '£10000' },
];

const faceTheConsequences = (data, value, updateOption) => {
  const newValue = {
    ...data,
    value,
  };
  updateOption({ id: 'consequentialLoss', value: newValue });
};

const renderObjectOfConsequence = (data, updateOption) => {
  const { value } = data;
  const titleOfConsequence = value.length > 0 ? value : '';
  const label = <FormattedMessage defaultMessage='Loss Amount' description='otherShippingOptions.consequential.lossAmount' id='Y96/zN' />;
  return (
    <div className={style['other-input']}>
      <DropdownMenu>
        <DropdownMenuToggler>
          <DropdownMenuTitleWithLabel label={label} title={titleOfConsequence} />
        </DropdownMenuToggler>
        {CONSEQUENTIAL_LOSSES.map((option) => (
          <DropdownMenuItem key={option.id} onClick={() => updateOption(option.id)}>
            {option.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

export const ConsequentialLossOption = ({ label, checked = false, onCheck = noop, optionData = emptyObject, updateOption = noop }) => (
  <div>
    <Checkbox checked={checked} label={label} onChange={onCheck} />
    {checked && renderObjectOfConsequence(optionData, (optionId) => faceTheConsequences(optionData, optionId, updateOption))}
  </div>
);

ConsequentialLossOption.propTypes = {
  label: FormattedMessagePropType.isRequired,
  checked: PropTypes.bool,
  onCheck: PropTypes.func,
  optionData: PropTypes.shape({
    value: PropTypes.string,
  }),
  updateOption: PropTypes.func,
};
